import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events, AlertController } from 'ionic-angular';
import { HttpClient } from '../../../../services/HttpClient';
import { CustomToast } from '../../../../util/CustomToast';
import * as moment from 'moment';

@Component({
  selector: 'page-seminary',
  templateUrl: 'seminary.html',
  providers : [HttpClient, CustomToast]
})
export class SeminaryPage {

  modalCtrl : ModalController;
	
  httpClient : HttpClient;

  seminary = {
    id: -1,
    title_es : '',
    title_en : '',
    lecturer: '',
    conference_center_es : '',
    conference_center_en : '',
    place : '',
    conference_date : '',
    conference_type : '',
    url : ''
  };

  customToast : CustomToast;
  events : Events;
  alertCtrl : AlertController;

  minDate = moment().subtract(20,'years').toISOString();
  maxDate = moment().add(20,'years').toISOString();

	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,customToast : CustomToast,modalCtrl : ModalController, events : Events, alertCtrl : AlertController) {
		this.modalCtrl = modalCtrl;
    this.httpClient = httpClient;
    this.customToast = customToast;
    this.events = events;
    this.alertCtrl = alertCtrl;
    let id = navParams.get('id');
    this.httpCallSeminary(id);
	}

  httpCallSeminary(id){
    this.httpClient.get('/seminars/'+id,(error,data)=>{
      if(!error){
        this.seminary = data.json();
        console.log(this.seminary)
      }
    });
  }

  httpUpdateSeminary(){
    this.seminary.conference_date = this.seminary.conference_date.split('T')[0];
    this.httpClient.put('/seminars',this.seminary,(error,data)=>{
      if(!error){
        this.customToast.showMessage('Seminario actualizado correctamente',2000);
        this.navCtrl.pop();
        this.events.publish('seminary:update');
      }
    });
  }

  onClickSave(){
    this.httpUpdateSeminary();
  }

  onClickDelete(){
    let alert = this.alertCtrl.create({
      title : '¿Estas seguro?',message : 'Vas a eliminar la información de este seminario',
      buttons:[{
        text : 'No',
        role : 'cancel'
        },
        {
        text : 'Si',
        role : 'confirm',
          handler : ()=>{
            this.httpCallDelete();
          }
        }
      ]
    });
    alert.present();
  }

  httpCallDelete(){
    this.httpClient.delete('/seminars/'+this.seminary.id,(error,data)=>{
      if(!error){
        this.customToast.showMessage('Seminario eliminado correctamente',2000);
        this.navCtrl.pop();
        this.events.publish('seminary:delete');
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/seminars/seminary/seminary.ts